import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  urlForm: PropTypes.string,
  formTitle: PropTypes.string,
}

const FeedbackFormDirectButton = props => {
  const { formTitle, urlForm } = props
  const href = '/help' + urlForm

  return (
    <div className="flex flex-wrap justify-center w-full h-auto overflow-hidden">
      <span className="block w-full py-2 font-semibold text-center text-secondary">
        {formTitle}
      </span>
      <a
        href={href}
        className="px-8 py-3 text-center rounded-lg sm:px-6 bg-secondary hover:bg-secondary-dark"
      >
        <span className="font-semibold text-white whitespace-no-wrap">
          Enquiry Form
        </span>
      </a>
    </div>
  )
}

FeedbackFormDirectButton.propTypes = propTypes

export default FeedbackFormDirectButton
